<template>
  <div class="aboutUs">
    <div class="header">
      <h5>About us</h5>
      <a href="/">
      <span class="back">
        <img src="../../assets/images/back.png">
      </span>
      </a>
    </div>
    <div class="inner">
      <h5>
        Background of Card Times
      </h5>
      <p>
        In the spring of 2019, a group of ordinary, original, direct gift card holders in Nigeria came to us, hoping that we can offer them with some safe and honest gift card vendors. In the past, most gift card transactions were off-platform. At this time, with the deep feeling of poor and blocked gift card transactions information, we began to explore a way to unblock gift card transaction information, and then created Card Times, meaning, gift card timely news.
      </p>
      <h5>
        What is Card Times
      </h5>
      <p>
        Card Times is a digital media informative platform dedicated to timely sharing professional gift card trade knowledge, quickly establishing links between gift card suppliers, gift card vendors and final gift card buyers or customers, and incubating and copying more professional and trustworthy gift card trading brands. We are here to gather energy and share energy. Established on April 13, 2019, Card Times holds the position: to be a professional knowledge of gift card exchange; the vision: to promote global gift card transactions more professional, fair and transparent; the mission: to help gift card traders all over the world learn more about gift cards and the trading markets.
      </p>
      <h5>
        Memorabilia of Card Times Memorabilia
      </h5>
      <p>
        2019.04.13-2020.01 Positioned as a blog platform for gift card transaction knowledge sharing, offering gift card traders with professional knowledge of gift cards and transactions;
      </p>
      <p>
        2020.01-2020.09 Positioned as a intelligent service provider platform for the gift card transaction, helping many ordinary gift card holders or gift card suppliers, gift card vendors, and final gift card consumers establish fast and transparent contacts, accelerate gift card exchange;
      </p>
      <p>
        2020.09-present Positioned as a traffic sharing platform for gift card exchange branded companies, playing the role of replicating more professional, trustworthy and convenient gift card exchange platforms and branded companies around the world.
      </p>
      <p>
        Today, Card Times has always kept in mind its platform positioning. That is no matter how the platform develops, our business will only increase and will not change.
      </p>
    </div>
    <div class="foot">
      <div class="section">
        <div class="list">
          <h5>Cardpedia</h5>
          <a href="about.html"><p>About us</p></a>
          <a href="contact.html"><p>Contact us</p></a>
          <a href="business.html"><p>Business</p></a>
        </div>
        <div class="list">
          <h5>{{footNav1.englishName}}</h5>
          <p 
            v-for="(item, index) in footNav1.blogList" 
            :key="index">
            <a :href="item.urlH5">
              {{item.artTitle}}
            </a>
          </p>
        </div>
      </div>
      <div class="section" 
        v-for="item in footNav2" 
        :key="item.id">
        <div class="list">
          <h5>{{item.englishName}}</h5>
          <p 
            v-for="(items, index) in item.blogList" 
            :key="index">
            <a :href="items.urlH5">
              {{items.artTitle}}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components:{

  },
  data () {
    return {
      footNav1:{},
      footNav2:[],
    }
  },
  computed:{

  },
  methods:{
    async getHost(url){
      if(url.indexOf('test') != -1){
        //测试
        return `//${url.replace('h5test.', 'pctest.')}/blog`
      }else{
        //正式
        return `//${url.replace('h5.', '')}/blog`
      }
    },
    //获取底部导航
    async getFootNav(){
      const res = await this.$api.home.getFootNav({
        params:{
          subsidiaryCode: 'blog000000001',
        }
      })
      let url = await this.getHost(window.location.host)
      for(let i=0; i<res.length; i++){
        for(let j=0; j<res[i].blogList.length; j++){
          res[i].blogList[j].urlH5 = `${url}/${res[i].blogList[j].urlH5}`
        }
      }
      this.footNav1 = res[0]
      this.footNav2 = res.slice(1)
    }
  },
  created(){
    //获取底部导航
    this.getFootNav()
  },
  mounted(){

  },
  watch:{

  }
}
</script>

<style lang="less" scoped>
.aboutUs{
  .header{
    padding: 15px 0;
    position: relative;
    border-bottom: 1px solid #e2e2e2;
    h5{
      font-size: 17px;
      font-weight: 600;
      color: #333333;
      text-align: center;
    }
    span{
      position: absolute;
      top: 12px;
      left: 15px;
      img{
        width: 26px;
      }
    }
  }
  .inner{
    padding: 25px 15px;
    h5{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 20px;
    }
    p{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-bottom: 15px;
      line-height: 20px;
    }
    p:last-child{
      margin-bottom: 0;
    }
  }
  .foot{
    background: #E2EAFB;
    padding: 15px;
    .section{
      display: flex;
      margin-top: 20px;
      .list{
        h5{
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          margin-bottom: 20px;
        }
        p{
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin-bottom: 15px;
          a{
            color: #666666;
          }
        }
      }
      .list:first-child{
        margin-right: 60px;
      }
    }
  }
}
</style>
